import React, {useCallback, useState} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {currentResource} from '../../../../util/utils';
import {Entity} from '../../../../util/uiconstants';
import {useEngagementId} from '../../../../util/customHooks';
import {deleteMultiEntity, getALLMultiEntity} from '../../../../actions/MultiEntities/stEntitiesactions';
import {getAllStEntities} from '../../../../selectors/Ares/selectors';
import Button from '../../BaseComponentWrappers/MotifButton';
import EntitiesModalWrapper from '../../EntityCrud/EntitiesModalWrapper';

export default function ManageEntities({onClose, className}) {
	const [showEntitiesModal, setShowEntitiesModal] = useState(false);

	const entities = useSelector((store) => getAllStEntities(store, true));
	const engagementId = useEngagementId();

	const actionProps = {isManageEntities: true};

	const handleOnModalOpen = useCallback(() => {
		setShowEntitiesModal(true);
	}, []);

	const handleOnModalClose = useCallback(() => {
		setShowEntitiesModal(false);
		onClose && onClose();
	}, [onClose]);

	const handleGetAllEntities = useCallback(() => {
		return getALLMultiEntity(
			engagementId,
			{
				pageSize: -1
			},
			actionProps
		);
	}, [engagementId]);

	const handleDeleteEntity = useCallback(
		(id) => {
			return deleteMultiEntity(engagementId, id, actionProps);
		},
		[engagementId]
	);

	const manageEntitiesLabel = currentResource.EntitiesLabels[Entity.STEntity]?.manageEntity;

	const formattedEntities =
		entities?.map((entity) => {
			return {
				...entity,
				name: entity.stEntityName
			};
		}) || [];

	return (
		<StyledManageEntities className={`StyledManageEntities${className ? ' ' + className : ''}`}>
			<Button
				variant="text-alt"
				className="manageEntities"
				onClick={handleOnModalOpen}
				showLabel
				isEllipsed
				buttonLabel={manageEntitiesLabel}
				noOfLines={1}
			/>
			{showEntitiesModal && (
				<EntitiesModalWrapper
					isManageEntities
					engagementId={engagementId}
					show={showEntitiesModal}
					entityType={Entity.STEntity}
					setShow={setShowEntitiesModal}
					getAllAction={handleGetAllEntities}
					entities={formattedEntities}
					onClose={handleOnModalClose}
					deleteAction={handleDeleteEntity}
				/>
			)}
		</StyledManageEntities>
	);
}

const StyledManageEntities = styled.section`
	display: flex;
	justify-content: flex-end;
	margin-right: var(--px-10);
`;
